interface BeforeInstallPromptEvent extends Event {
    prompt: () => Promise<void>;
    userChoice: Promise<{ outcome: 'accepted' | 'dismissed' }>;
}

let deferredPrompt: BeforeInstallPromptEvent | null = null;

window.addEventListener('beforeinstallprompt', (e: Event) => {
    e.preventDefault();
    deferredPrompt = e as BeforeInstallPromptEvent;
});

export const getPwaInstallPrompt = (): BeforeInstallPromptEvent | null => deferredPrompt;

export const setPwaInstallPrompt = (prompt: BeforeInstallPromptEvent | null): void => {
    deferredPrompt = prompt;
};

export const clearPwaInstallPrompt = (): void => {
    deferredPrompt = null;
};
